
const install = {
    //自动注册全局组件
    install:Vue =>{
        const componentsContext = require.context("@/components/", true, /\.vue$/);
        componentsContext.keys().forEach((component) => {
            const componentConfig = componentsContext(component);
            /**
             * 兼容 import export 和 require module.export 两种规范
             */
            const ctrl = componentConfig.default || componentConfig;
            Vue.component(!!ctrl.options? ctrl.options.name : ctrl.name, ctrl);
        });
    }
}

export default install;